module.exports = __webpack_public_path__ + "static/deliveroo@2x-2b8f7bf219d0bb591959f35824b17d9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/deliveroo@2x.png
// module id = 2681
// module chunks = 157636680307020